module.exports = __webpack_public_path__ + "static/img/zitu.a734497.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zitu.png
// module id = 9iYg
// module chunks = 0